/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3Proposals } from "../../funcs/proposalsGetApiV3Proposals.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ProposalsRequest$inboundSchema.optional(),
};

export const tool$proposalsGetApiV3Proposals: ToolDefinition<typeof args> = {
  name: "proposals-get-api-v3-proposals",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3Proposals(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
